var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre_input',{attrs:{"value":_vm.value,"label":_vm.label,"md":_vm.md,"tag":_vm.c_tag,"view_only":_vm.view_only}},[_c('v-checkbox',{staticStyle:{"margin-top":"0"},attrs:{"label":_vm.label,"prepend-icon":_vm.prepend_icon,"append-icon":_vm.append_icon},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }